import { render, staticRenderFns } from "./image.email.notice.vue?vue&type=template&id=57dd5a2d"
import script from "./image.email.notice.vue?vue&type=script&lang=js"
export * from "./image.email.notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports